import { RecommendedArticle } from './RecommendedArticle'
import { withRecommendedArticle } from './withRecommendedArticle'

const ConnectedRecommendedArticle = withRecommendedArticle(RecommendedArticle)

export { ConnectedRecommendedArticle as RecommendedArticle }
